import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetojalgaoncabservice() {



const cardData = {
  keyword: " Pune to Jalgaon Cab Service ",

"headingDescription": "SRS Cab Service offers Pune to Jalgaon Cab Service, providing a safe, comfortable, and reliable travel solution for business travelers, corporate clients, and tourists. Our well-maintained vehicles, professional drivers, and punctual pickups ensure a smooth journey from Pune to Jalgaon. Ideal for long-distance travel, family trips, corporate travel, and personal journeys, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a stress-free and enjoyable ride.",
"topPlaces": [
  {
    "title": "Ajanta Caves",
    "description": "Ajanta Caves are UNESCO World Heritage rock-cut Buddhist cave monuments near Jalgaon, known for ancient paintings and sculptures. Travelers using SRS Cab Service often visit to explore this historic site."
  },
  {
    "title": "Ellora Caves",
    "description": "Ellora Caves are a UNESCO-listed complex featuring Hindu, Buddhist, and Jain temples carved into rock. Visitors using SRS Cab Service often include this destination for cultural exploration."
  },
  {
    "title": "Gandhi Research Foundation",
    "description": "Gandhi Research Foundation in Jalgaon is a museum and learning center dedicated to Mahatma Gandhi’s life and teachings. Travelers using SRS Cab Service often visit for educational experiences."
  },
  {
    "title": "Omkareshwar Temple",
    "description": "Omkareshwar Temple in Jalgaon is a peaceful spiritual destination dedicated to Lord Shiva. Visitors using SRS Cab Service often come here for religious visits and tranquility."
  },
  {
    "title": "Mehrun Lake",
    "description": "Mehrun Lake is a popular picnic and relaxation spot in Jalgaon surrounded by greenery. Travelers using SRS Cab Service often visit for evening leisure and nature views."
  },
  {
    "title": "Manudevi Temple",
    "description": "Manudevi Temple is a scenic hill temple located near Jalgaon, known for its waterfalls and peaceful environment. Visitors using SRS Cab Service often visit for spiritual and natural beauty."
  },
  {
    "title": "Padmalaya Ganpati Temple",
    "description": "Padmalaya Ganpati Temple is a revered religious site dedicated to Lord Ganesha, attracting devotees from across Maharashtra. Travelers using SRS Cab Service often visit for blessings."
  },
  {
    "title": "Shree Sant Muktabai Temple",
    "description": "Shree Sant Muktabai Temple is an important spiritual site associated with the Warkari tradition. Visitors using SRS Cab Service often come for pilgrimage and cultural significance."
  },
  {
    "title": "Bahula Fort",
    "description": "Bahula Fort is a historical hill fort offering trekking opportunities and panoramic views. Travelers using SRS Cab Service often visit for adventure and exploration."
  },
  {
    "title": "Waghur Dam",
    "description": "Waghur Dam is a scenic water reservoir near Jalgaon, known for its calm surroundings and natural beauty. Visitors using SRS Cab Service often enjoy peaceful outings here."
  }
],



"services": [
    {
      "name": "Pune to Jalgaon Cab Service",
      "description": "Pune to Jalgaon cab service offers reliable and comfortable intercity travel for passengers. Customers can book cabs for business trips, family travel, or personal journeys. Professional drivers ensure safe highway driving. Well-maintained vehicles enhance travel comfort. Flexible booking options are available. Travel easily with trusted cab services."
    },
    {
      "name": "Pune to Jalgaon Taxi Service",
      "description": "Pune to Jalgaon taxi service provides convenient transportation for long-distance travel. Customers can book taxis for smooth and hassle-free journeys. Experienced drivers ensure safe travel. Comfortable seating enhances the experience. Flexible booking options are available. Travel easily with taxi services."
    },
    {
      "name": "Pune to Jalgaon Cab Booking",
      "description": "Pune to Jalgaon cab booking allows customers to reserve rides quickly and easily. Users can book cabs online or via call for instant travel needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab booking services."
    },
    {
      "name": "Pune to Jalgaon Taxi Fare",
      "description": "Pune to Jalgaon taxi fare offers transparent and affordable pricing for customers. Users can plan travel with clear cost estimates. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. No hidden charges ensure trust. Travel easily with budget-friendly taxi services."
    },
    {
      "name": "One Way Cab Pune to Jalgaon",
      "description": "One way cab Pune to Jalgaon offers cost-effective travel without return charges. Customers can book direct drop services easily. Professional drivers ensure safe highway journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way cab services."
    },
    {
      "name": "Round Trip Cab Pune to Jalgaon",
      "description": "Round trip cab Pune to Jalgaon provides flexible travel for return journeys. Customers can book cabs for multiple-day trips. Professional drivers ensure safe travel. Comfortable vehicles enhance long-distance experience. Flexible booking options are available. Travel easily with round trip cab services."
    },
    {
      "name": "Pune to Jalgaon Car Rental",
      "description": "Pune to Jalgaon car rental offers reliable vehicle options for intercity travel. Customers can choose from sedans, SUVs, and premium cars. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible rental options are available. Travel easily with car rental services."
    },
    {
      "name": "Pune to Jalgaon Innova Cab",
      "description": "Pune to Jalgaon Innova cab provides spacious and comfortable SUV travel. Customers can enjoy extra legroom and luggage space. Professional drivers ensure safe journeys. Ideal for family and group travel. Transparent pricing ensures value. Travel easily with Innova cab services."
    },
    {
      "name": "Pune to Jalgaon Innova Crysta Cab",
      "description": "Pune to Jalgaon Innova Crysta cab offers premium SUV travel with luxury comfort. Customers can enjoy plush seating and smooth rides. Professional drivers ensure safe journeys. Ideal for corporate and family travel. Transparent pricing ensures value. Travel easily with Innova Crysta services."
    },
    {
      "name": "Pune to Jalgaon Ertiga Cab",
      "description": "Pune to Jalgaon Ertiga cab offers comfortable 7 seater travel for small groups. Customers can enjoy spacious seating and smooth journeys. Professional drivers ensure safe travel. Ideal for family trips. Transparent pricing ensures affordability. Travel easily with Ertiga cab services."
    },
    {
      "name": "Pune to Jalgaon Dzire Cab",
      "description": "Pune to Jalgaon Dzire cab provides economical sedan travel for passengers. Customers can book budget-friendly rides for intercity travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Transparent pricing ensures affordability. Travel easily with Dzire cab services."
    },
    {
      "name": "Pune to Jalgaon Sedan Cab",
      "description": "Pune to Jalgaon sedan cab offers comfortable and affordable travel for individuals and small families. Customers can enjoy smooth rides and ample space. Professional drivers ensure safe journeys. Fuel-efficient vehicles reduce costs. Flexible booking options are available. Travel easily with sedan cab services."
    },
    {
      "name": "Pune to Jalgaon SUV Cab",
      "description": "Pune to Jalgaon SUV cab provides spacious and powerful vehicles for long-distance travel. Customers can enjoy extra comfort and luggage capacity. Professional drivers ensure safe journeys. Ideal for group travel. Flexible booking options are available. Travel easily with SUV cab services."
    },
    {
      "name": "Pune to Jalgaon Luxury Cab",
      "description": "Pune to Jalgaon luxury cab offers premium travel experience with high-end vehicles. Customers can enjoy superior comfort and style. Professional drivers ensure safe journeys. Ideal for corporate and VIP travel. Luxury interiors enhance experience. Travel easily with luxury cab services."
    },
    {
      "name": "Pune to Jalgaon Tempo Traveller",
      "description": "Pune to Jalgaon tempo traveller provides comfortable group travel for larger passengers. Customers can book vehicles for tours, events, and family trips. Professional drivers ensure safe journeys. Spacious seating enhances comfort. Flexible booking options are available. Travel easily with tempo traveller services."
    },
    {
      "name": "Pune to Jalgaon Urbania Cab",
      "description": "Pune to Jalgaon Urbania cab offers premium group travel with modern design vehicles. Customers can enjoy high-roof spacious seating. Professional drivers ensure safe journeys. Ideal for corporate and family groups. Comfortable interiors enhance experience. Travel easily with Urbania cab services."
    },
    {
      "name": "Cheap Cab Pune to Jalgaon",
      "description": "Cheap cab Pune to Jalgaon offers budget-friendly travel options for customers. Users can book affordable rides without compromising comfort. Professional drivers ensure safe journeys. Well-maintained vehicles enhance experience. Transparent pricing ensures trust. Travel easily with economical cab services."
    },
    {
      "name": "Best Taxi Pune to Jalgaon",
      "description": "Best taxi Pune to Jalgaon provides top-rated travel experience for customers. Users can enjoy reliable and comfortable journeys. Professional drivers ensure safe travel. Premium vehicles enhance experience. Flexible booking options are available. Travel easily with best taxi services."
    }
  ],
  "tableData": [
    ["Pune to Jalgaon Cab Service","Pune to Jalgaon Taxi Service"],
    ["Pune to Jalgaon Cab Booking","Pune to Jalgaon Taxi Fare"],
    ["One Way Cab Pune to Jalgaon","Round Trip Cab Pune to Jalgaon"],
    ["Pune to Jalgaon Car Rental","Pune to Jalgaon Innova Cab"],
    ["Pune to Jalgaon Innova Crysta Cab","Pune to Jalgaon Ertiga Cab"],
    ["Pune to Jalgaon Dzire Cab","Pune to Jalgaon Sedan Cab"],
    ["Pune to Jalgaon SUV Cab","Pune to Jalgaon Luxury Cab"],
    ["Pune to Jalgaon Tempo Traveller","Pune to Jalgaon Urbania Cab"],
    ["Cheap Cab Pune to Jalgaon","Best Taxi Pune to Jalgaon"]
  ],



whychoose: [
  {
    WhyChooseheading: "Reliable Pune to Jalgaon Cab Service",
    WhyChoosedescription: "SRS Cab Service offers dependable Pune to Jalgaon cab service for safe and comfortable long-distance travel. Customers can enjoy smooth journeys with professional drivers and well-maintained vehicles."
  },
  {
    WhyChooseheading: "Affordable Pune to Jalgaon Cab Pricing",
    WhyChoosedescription: "We provide budget-friendly cab services from Pune to Jalgaon with transparent pricing. Customers receive full fare details including tolls and driver charges with no hidden costs."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long-distance highway routes, ensuring safe, smooth, and stress-free travel between Pune and Jalgaon."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Pune to Jalgaon cab bookings, making it ideal for business travel, family trips, and urgent journeys."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "We provide clean, well-maintained, and air-conditioned vehicles to ensure a comfortable and relaxing travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Customers can choose from one-way cab service, round-trip bookings, and multi-day travel options based on their needs."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer hatchbacks, sedans, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for individuals and group travel."
  },
  {
    WhyChooseheading: "Trusted Pune to Jalgaon Cab Booking",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Jalgaon cab bookings due to punctual service, professional drivers, and reliable travel experience."
  }
]
}

const faqData = [
  { question: "Do you provide Pune to Jalgaon cab service?", answer: "Yes, SRS Cab Service offers reliable cab services from Pune to Jalgaon for all travel needs." },
  { question: "What is the distance between Pune and Jalgaon?", answer: "The distance is approximately 400–420 km and takes around 8 to 9 hours depending on traffic and route." },
  { question: "What is the starting cab fare?", answer: "Cab fares typically start from ₹6000–₹9000 depending on vehicle type and travel timing." },
  { question: "Is one-way cab available?", answer: "Yes, one-way cab services are available and are more affordable compared to round-trip bookings." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Pune to Jalgaon cab service operates 24/7." },
  { question: "Which vehicles are available?", answer: "We offer hatchbacks, sedans, SUVs, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book cab online?", answer: "Yes, you can easily book your Pune to Jalgaon cab service online or via phone." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, office, or any location in Pune." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are properly cleaned and sanitized before every trip." },
  { question: "Do you provide Jalgaon city drop?", answer: "Yes, we provide drop service anywhere in Jalgaon including MIDC areas, railway station, and nearby locations." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Deepak Patil",
    feedback:
      "Booked Pune to Jalgaon cab with SRS Cab Service. Long journey but very comfortable and smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Anjali Deshmukh",
    feedback:
      "Excellent service from Pune to Jalgaon. Clean car, polite driver, and timely pickup.",
    rating: 5
  }
];




















const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Jalgaon Cab Service | SRS Cab Service",
  "description": "Book reliable Pune to Jalgaon cab service with SRS Cab Service. One-way and round trip taxis available with Innova Crysta, Ertiga, Dzire, SUV, sedan, luxury cars, tempo traveller, and Urbania for comfortable travel at best fares.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Pune",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411038",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5204",
    "longitude": "73.8567"
  },
  "url": "https://www.srscabservice.com/pune-to-jalgaon-cab",
  "areaServed": ["Pune", "Jalgaon", "Maharashtra"],
  "openingHours": "Mo-Su 00:00-23:59",
  "priceRange": "₹₹",
  "serviceType": [
    "Pune to Jalgaon Cab Service",
    "One Way Cab Pune to Jalgaon",
    "Round Trip Cab Pune to Jalgaon",
    "Pune to Jalgaon Taxi Service",
    "Pune to Jalgaon Car Rental",
    "SUV, Sedan, Innova Crysta, Ertiga, Luxury Cab, Tempo Traveller, Urbania"
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "710"
  }
};







  return (
    <div>

<Helmet>
  <title>Pune to Jalgaon Cab Service | SRS Cab Service</title>
  <meta
    name="description"
    content="Book Pune to Jalgaon cab service with SRS Cab Service. One way and round trip taxis available with Innova, Ertiga, Dzire, SUV, sedan, luxury cabs, tempo traveller and Urbania at best fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/116.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetojalgaoncabservice;